import { SceneConfig } from "../models/client";

export const sceneConfig: SceneConfig = {
  width: 2444,
  height: 1890,
};
